import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import {recordBigQueryEvent, setErrorOnPage, submitConfirm} from '../../../actions/paymentActions/threedsActions';
import Translation from '../../../lang/Translation';
import {getSettings} from '../../../selectors/selectors';
import Track from '../../../utils/tracking';
import PostToIframe from '../ProviderAgnostic/PostToIframe';
import './CheckoutcomChallenge.scss';

const PROVIDER = 'CHECKOUT_COM';

export class Checkoutcom3DSChallenge extends Component {
  constructor() {
    super();
    
    this.handleOnError = this.handleOnError.bind(this);
    this.handleTimout = this.handleTimout.bind(this);
  }
  
  componentDidMount() {
    window.addEventListener('message', this.messageCallback, false);
    this.timer = setTimeout(() => {
      try {
        recordBigQueryEvent('DataCollectionCompleted', PROVIDER, [{name: 'result', value: 'timeout'}], []);
      } catch (error) {
        Track.track(error);
      }
      this.props.submitConfirm(this.props.providerTransactionId);
    }, 600000);
  }
  
  componentWillUnmount() {
    clearTimeout(this.timer);
    this.removeListener();
  }
  
  handleOnError() {
    clearTimeout(this.timer);
    const errorMessage = 'Error loading Checkoutcom 3DS Challenge frame';
    Track.track(new Error(errorMessage));
    this.props.setErrorOnPage();
    this.props.submitConfirm(this.props.providerTransactionId);
    try {
      recordBigQueryEvent('2ChallengeCompleted', PROVIDER,
        [{name: 'result', value: 'error'}], [{type: 'loading', value: errorMessage}]);
    } catch (error) {
      Track.track(error);
    }
  }
  
  handleOnLoad = () => {
    try {
      recordBigQueryEvent('2ChallengeInitiated', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
  };
  
  handleTimout() {
    this.props.submitConfirm(this.props.providerTransactionId);
  }
  
  messageCallback = (event) => {
    let eventData = event.data;
    if (typeof eventData === 'string') {
      try {
        eventData = JSON.parse(event.data);
      } catch (error) {
        Track.error(`JSON parse error in Checkoutcom3DSChallenge. ${error}`);
        eventData = null;
      }
    }
    
    const providerTransactionId = eventData?.threeDSServerTransID || eventData?.providerTransactionId;
    
    if (!providerTransactionId) return;
    
    clearTimeout(this.timer);
    this.removeListener();
    this.timer = undefined;
    
    try {
      this.props.submitConfirm(providerTransactionId, true);
      
      try {
        recordBigQueryEvent('2ChallengeCompleted', PROVIDER, [{name: 'result', value: 'success'}], []);
      } catch (error) {
        Track.track(error);
      }
    } catch (error) {
      Track.track(error);
      this.props.submitConfirm(this.props.providerTransactionId);
    }
  };
  
  removeListener = () => {
    window.removeEventListener('message', this.messageCallback);
  };
  
  render() {
    const {
      issuerURL, oneTime3DSToken,
    } = this.props;
    try {
      recordBigQueryEvent('2ChallengeRequired', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
    
    return (
      
      <div className="CheckoutcomChallenge" data-test="Checkoutcom3DSChallenge">
        {this.props.showHelpText && (
          <p data-test="Checkoutcom3DSChallenge__text">
            <Translation>checkout.com.help.text</Translation>
          </p>
        )}
        <PostToIframe
          postURL={issuerURL}
          formFields={{
            creq: oneTime3DSToken,
          }}
          onError={this.handleOnError}
          onLoad={this.handleOnLoad}
        />
      </div>
    );
  }
}

Checkoutcom3DSChallenge.propTypes = {
  showHelpText: PropTypes.bool,
  providerTransactionId: PropTypes.string,
  
  setErrorOnPage: PropTypes.func.isRequired,
  submitConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  showHelpText: !!getSettings(state)?.show_checkout_com_help_text,
});

export default connect(mapStateToProps, {setErrorOnPage, submitConfirm})(Checkoutcom3DSChallenge);
